module.exports = __webpack_public_path__ + "static/media/1POLICY23.5b7b2f23.jpg";